<template>
  <Modal closable>
    <template v-slot:header>
      <h2>{{ $t('live.invite_driver') }}</h2>
    </template>

    <template v-if="state.isPrivate">
      <p>Denne rute er skjult. Hvis du vil invitére en chauffør til ruten, skal den være tilgængelig.</p>
      <div class="hint">Kun folk med linket kan <b>se</b> ruten, når den er privat.</div>
      <div class="flex flex-c" style="margin-top: 1rem">
        <AppButton @click="makePublic" :loading="state.loading" icon="public" color="primary">Gør tilgængelig</AppButton>
      </div>
    </template>

    <template v-else>
      <p>Nedenstående link giver chaufføren adgang til at styre ruten. Del <u>kun</u> med personer du ønsker skal kunne styre ruten!</p>
      <div v-if="state.driverLink">
        <div class="flex flex-sb-c">
          <input class="fill-x" :value="state.driverLink" v-focus style="margin: 1rem 0" spellcheck="false" readonly />
          <AppButton @click="copy()" icon="copy" color="primary" style="margin-left: .5rem" />
        </div>
        <div class="hint">Folk med linket kan <b>styre</b> Live Mode på denne rute.</div>
      </div>
    </template>

  </Modal>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive } from 'vue'
import { copyToClipboard } from '@/api/tools'
import { getDriverLink } from '@/api/tripply/live'
import { Route } from '@/api/tripply/models/Route'
import { store } from '@/store'

export default defineComponent({
  props: {
    route: {
      type: Object as PropType<Route>,
      required: true
    }
  },
  components: { },
  name: 'AssignDriver',
  setup(props) {

    
    
    const state = reactive({
      driverLink: getDriverLink(props.route.id),
      isPrivate: props.route.settings.private,
      loading: false
    })
        
    function copy() {
      state.driverLink && copyToClipboard(state.driverLink)
    }

    async function makePublic() {
      state.loading = true
      await store.route.updateSettings(props.route.id, { private: false })
      state.isPrivate = false
      state.loading = false
    }
    
    return { state, copy, makePublic }
  }
})
</script>

<style>

</style>